import { render, staticRenderFns } from "./TermsAndPolicy.vue?vue&type=template&id=5ef01c14&scoped=true&"
import script from "./TermsAndPolicy.vue?vue&type=script&lang=ts&"
export * from "./TermsAndPolicy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef01c14",
  null
  
)

export default component.exports